export enum DeadlinePeriodType {
  COLLECTION_PERIOD = 'COLLECTION_PERIOD',
  RESULT_RECORDING_PERIOD = 'RESULT_RECORDING_PERIOD',
  EVALUATION_PERIOD_1 = 'EVALUATION_PERIOD_1',
  CORRECTION_PERIOD = 'CORRECTION_PERIOD',
  EVALUATION_PERIOD_2 = 'EVALUATION_PERIOD_2',
  COMMENT_PERIOD = 'COMMENT_PERIOD',
  NO_PERIOD = 'NO_PERIOD',
}
